define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/form/Widget",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType",
	"./ReplaceFixedMaterialForm"
], function(array,declare,lang,Memory,csi,Controller,PostRequest,FormWidget,ActionControllerMixin,xml,Query,ProductType) {

	var FIELD_TO = "ReplaceFixedMaterialTo";
	var FIELD_RETAIN = "ReplaceFixedMaterialRetain";

	return declare([Controller, ActionControllerMixin], {
		getFormData: function() {
			// summary: make sure that at least one Style is selected
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			return fd;
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for styles view
			var	q;

			if (index > 0) {
				var psPlacement = view.getViewNode();
				var productStructure = this.m_cache.getNode(psPlacement.__Parent__);

				q = new Query();
				if (psPlacement.$URL == productStructure.Placements[0]) {
					// tool placement: all styles with this PS
					q.RefAttr("ProductStructure", xml.OP_EQUALS, productStructure.$URL, "Child:Spec");
				} else {
					// non-tool placement: styles with draft BOMs with this PS
					q.RefAttr("BOMStructure", xml.OP_EQUALS, productStructure.$URL, "Child:DataSheets/Child:CurrentRevision");
					q.Attr("State", xml.OP_EQUALS, "Revision.State:DRAFT", "Child:DataSheets/Child:CurrentRevision");
				}

				if (!view.isStarted()) {
					// add existing filters from table view - only needs to be done first time
					view.copyQuery(this.widget);
				}
			}

			return q;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
		},

		process: function() {
			// summary: issue request using PostRequest so we get the return value
			var	fd = this.m_formData;
			var	req = new PostRequest("MaterialSpec", "ProductStructureReplaceFixedMaterial")
				.addParameter(xml.PROP_URL, this.m_urlNode)
				.addParameter("ReplaceFixedMaterialTo", fd.getFieldValue(FIELD_TO))
				.addParameter("ReplaceFixedMaterialRetain", fd.getFieldValue(FIELD_RETAIN));

			var	nodes = fd.getSelectedNodes(true);
			if (nodes.length) {
				req.addParameter(xml.PROP_AGGREGATE_ADDS, array.map(nodes, xml.nodeGetURL));
			}

			req.post({}).then(lang.hitch(this, this._onPublishResponse));
		}
	});
});